<style scoped>
    .foot {
        padding-top: 20px;
        margin-top: 20px;
    }

    .amap-style {
        height: 360px;
    }

    .amap-search-box {
        top: 66px;
        left: 8px;
        position: absolute;
        width: calc(100% - 16px);
        border-top: 1px solid #f1f1f1;
        margin-top: 10px;
    }
</style>
<template>
    <div style="padding: 20px 0;">
        <div style="font-size: 20px;padding: 0 20px;">
            <div>选择门店</div>
        </div>
        <div style="border-top: 1px solid #f1f1f1;border-bottom: 1px solid #f1f1f1;margin-top: 20px;">
            <el-amap-search-box class="amap-search-box" :search-option="amap.searchOption" :on-search-result="onSearchResult"></el-amap-search-box>
            <el-amap :center="amap.center" :zoom="amap.zoom" class="amap-style" :events="amap.events">
                <el-amap-marker :position="amap.marker.position" :events="amap.marker.events" :draggable="true"></el-amap-marker>
            </el-amap>
        </div>
        <div class="foot jcsb" style="padding: 0 20px;">
            <div></div>
            <div class="center">
                <Button @click="cancel" style="margin-right: 10px;">取消</Button>
                <Button type="primary" @click="locationConfirm">确定</Button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            current: Object,
        },
        data() {
            return {
                loading: false,
                query: {
                    keywords: '',
                    init: true,
                },
                usedKeywords: '',
                amap: {
                    zoom: 14,
                    center: [104.065778, 30.657487],
                    lng: 0,
                    lat: 0,
                    address: '',
                    events: {},
                    dragoffset: {
                        x: 0,
                        y: 0
                    },
                    marker: {
                        position: [104.065778, 30.657487],
                        events: {
                            dragstart: (e) => {
                                this.amap.dragoffset.x = e.lnglat.lng - this.amap.marker.position[0]
                                this.amap.dragoffset.y = e.lnglat.lat - this.amap.marker.position[1]
                            },
                            dragend: (e) => {
                                this.amap.lng = e.lnglat.lng - this.amap.dragoffset.x
                                this.amap.lat = e.lnglat.lat - this.amap.dragoffset.y
                                this.amap.marker.position = [this.amap.lng, this.amap.lat];
                            }
                        }
                    },
                    searchOption: {
                        city: '成都',
                        citylimit: false
                    }
                },
                location: null,
            }
        },
        mounted() {
            this.loadData()
            if (this.current) {
                this.amap.center = this.current
                this.amap.marker.position = this.current
            }

        },
        methods: {
            locationConfirm() {
                if (!this.amap.lng) {
                    this.location = this.amap.center
                } else {
                    this.location = [this.amap.lng, this.amap.lat]
                }
                this.$emit('locationSelected', this.location)
            },
            locationCancel() {
                if (this.location) {
                    this.amap.center = this.location
                    this.amap.marker.position = this.location
                }
            },
            onSearchResult(pois) {
                let latSum = 0;
                let lngSum = 0;
                if (pois.length > 0) {
                    pois.forEach(poi => {
                        let { lng, lat } = poi;
                        lngSum += lng;
                        latSum += lat;
                    });
                    let center = {
                        lng: lngSum / pois.length,
                        lat: latSum / pois.length
                    };
                    this.amap.center = [center.lng, center.lat]
                    this.amap.marker.position = [center.lng, center.lat]
                    this.amap.lng = center.lng
                    this.amap.lat = center.lat
                }
            },
            loadData() {
                let that = this
                that.loading = true
                that.$api.post('/web/main/locationselector/load', {
                    query: this.query,
                }).then(res => {
                    that.loading = false
                    if (res.data.success) {
                        if (that.query.init) {
                            that.query.init = false
                        }
                        that.usedKeywords = that.query.keywords
                    }
                }, () => {
                    that.loading = false
                })
            },
            search() {
                this.loadData()
            },
            cancel() {
                this.$emit('cancel')
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/common/LocationSelector.vue?631e8d48